import { CLASSES } from "@/scripts/helpers/constants";

export const setPlanButtonUrl = period => {
  $(".js-choose-plan").each(function() {
    const href = $(this).attr("url");
    const path =
      window.innerWidth < 640
        ? "/payment"
        : `/purchase/${$(this).attr("plan")}/loggedout`;
    const planPeriod =
      period === "price-monthly" ? "route-monthly" : "route-yearly";
    let fullLink = `${href}${path}?frequency=${$(this).data(planPeriod)}`;

    if (window.innerWidth < 640) {
      fullLink = `${fullLink}&plan=${$(this).attr("plan")}`;
    }

    $(this).attr("href", fullLink);
  });
};

$(window).resize(function() {
  setPlanButtonUrl();
});

export const switchPriceHandler = () => {
  const switchButton = $(".js-switcher");
  const priceItem = $(".price-block__count span");

  switchButton.on("click touchstart", function(e) {
    e.preventDefault();

    const period =
      $(this).text() === "Bill Monthly" ? "price-monthly" : "price-yearly";

    priceItem.each(function() {
      $(this).text($(this).data(period));
      setPlanButtonUrl(period);
    });

    switchButton.removeClass(CLASSES.IS_ACTIVE);
    $(this).addClass(CLASSES.IS_ACTIVE);
  });
};

export const accordionPricing = () => {
  const pricingItem = $(".js-accordion-pricing");
  const pricingItemHandler = $(".js-accordion-pricing-trigger");

  pricingItemHandler.click(function(e) {
    e.preventDefault();

    if (
      !$(this)
        .closest(".js-accordion-pricing")
        .hasClass(CLASSES.IS_ACTIVE)
    ) {
      pricingItem.removeClass(CLASSES.IS_ACTIVE);
    }

    $(this)
      .closest(".js-accordion-pricing")
      .toggleClass(CLASSES.IS_ACTIVE);
  });
};
